/* ===========================================================================
 * Maison Broderie — Page Accueil : interactions
 * Repris de script-v3.js (maquette V8), nettoyé pour la production :
 *   - Révélations au scroll (IntersectionObserver, repli prefers-reduced-motion)
 *   - Newsletter footer
 *   - Carrousel piliers (auto 6s, pause survol/hors-écran, clavier, swipe)
 *   - Filtre des cadres + station de cadrage
 *   - Lightbox YouTube in-site (vidéothèque, accessoires « unboxing »)
 *   - Onglets vidéothèque + onglets accessoires compris
 * RETIRÉ : panneau « tweaks » de l'outil de design (et son postMessage parent),
 * le chrome (méga-menu, repli barre d'annonce, tiroirs) est géré inline dans le
 * HTML (repris de Page Salons.html). Les modules « header shrink » / « carrousel
 * salon » restent inoffensifs : aucun élément cible sur cette page.
 * =========================================================================== */

/* Maison Broderie — Homepage V3 interactions
 * - Sticky header shrink after 100px
 * - Fade-in on scroll (IntersectionObserver)
 * - Newsletter form (footer)
 * - Salon carousel
 * - Cadres filter tabs
 * - Tweaks panel (extended : accent · hero · theme · density · typo · bg)
 */

(function () {
  'use strict';

  /* ===== Header shrink ===== */
  const header = document.querySelector('.header');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 100) header.classList.add('shrunk');
      else header.classList.remove('shrunk');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ===== Fade-in on scroll (+ cascade pour .reveal-stagger) ===== */
  const reveals = document.querySelectorAll('.reveal, .reveal-stagger');
  // Indexe les enfants directs des conteneurs en cascade : chaque enfant entre
  // avec un léger décalage (--mb-rvl-i piloté par CSS), plafonné pour que les
  // grandes grilles ne traînent pas. Cf [[prefs-animations]].
  document.querySelectorAll('.reveal-stagger').forEach((c) => {
    Array.prototype.forEach.call(c.children, (child, i) => {
      child.style.setProperty('--mb-rvl-i', Math.min(i, 8));
    });
  });
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('in'));
  }

  /* ===== Newsletter form (footer) ===== */
  const newsForm = document.querySelector('.footer-newsletter form');
  if (newsForm) {
    newsForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = newsForm.querySelector('input');
      const btn = newsForm.querySelector('button');
      if (input.value && /\S+@\S+\.\S+/.test(input.value)) {
        const original = btn.textContent;
        btn.textContent = 'Inscrit ✓';
        btn.disabled = true;
        input.value = '';
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2500);
      } else {
        input.focus();
      }
    });
  }

  /* ===== KESI — confirmation après envoi du formulaire client Shopify =====
     Shopify redirige vers la page avec ?customer_posted=true après un envoi
     « form_type=customer » réussi. On affiche alors le message de confirmation
     et on amène l'utilisateur dessus. */
  const kesiForm = document.querySelector('[data-kesi-form]');

  /* Affiche la confirmation : on masque le formulaire et on révèle le message
     « Merci… », ce qui déclenche les animations CSS (coche qui se dessine + entrée). */
  function showKesiSuccess(form) {
    const ok = form.querySelector('.kesi-form-success');
    const fieldsWrap = form.querySelector('.kesi-form-fields');
    const trig = form.querySelector('[data-kesi-trigger]');
    if (!ok) return;
    if (fieldsWrap) fieldsWrap.hidden = true;
    if (trig) trig.hidden = true;
    ok.hidden = false;
    ok.scrollIntoView({ block: 'center', behavior: 'smooth' });
    ok.setAttribute('tabindex', '-1');
    ok.focus({ preventScroll: true });
  }

  if (kesiForm) {
    const kesiCard = kesiForm.closest('.gamme-card');
    const kesiBody = kesiForm.closest('.gamme-card-body');
    const kesiTrigger = kesiForm.querySelector('[data-kesi-trigger]');
    const kesiFields = kesiForm.querySelector('[data-kesi-fields]');
    let kesiRevealed = false;

    /* Verrouille la hauteur de la carte sur l'état « déplié » (le plus haut), afin
       qu'elle reste identique aux autres cartes, repliée comme dépliée. En plus, on
       aligne le corps blanc de la KESI sur celui des cartes produit : ainsi, repliée,
       la photo KESI s'arrête EXACTEMENT à la même hauteur que les autres photos (le
       blanc commence sur la même ligne). Au clic, le corps grandit et la photo
       rétrécit — toujours sans changement de hauteur de carte. */
    function lockKesiHeight() {
      if (!kesiCard || !kesiFields || !kesiTrigger) return;
      kesiCard.style.minHeight = '';
      if (kesiBody) kesiBody.style.minHeight = '';
      // Mesure l'état le plus haut : champs visibles, déclencheur masqué.
      kesiFields.hidden = false;
      kesiTrigger.hidden = true;
      const h = Math.ceil(kesiCard.getBoundingClientRect().height);
      kesiCard.style.minHeight = h + 'px';
      // Aligne le bas de la photo KESI sur celui des photos voisines.
      const refBody = document.querySelector('.gamme-card:not(.coming-soon) .gamme-card-body');
      if (kesiBody && refBody) {
        kesiBody.style.minHeight = Math.ceil(refBody.getBoundingClientRect().height) + 'px';
      }
      // Restaure l'état courant (replié tant qu'on n'a pas cliqué).
      kesiFields.hidden = kesiRevealed ? false : true;
      kesiTrigger.hidden = kesiRevealed ? true : false;
    }

    if (kesiCard && kesiTrigger && kesiFields) {
      // État initial : replié (progressive enhancement — sans JS, le formulaire
      // reste visible et utilisable). On verrouille AVANT de replier.
      lockKesiHeight();

      kesiTrigger.addEventListener('click', function () {
        kesiRevealed = true;
        kesiFields.hidden = false;
        kesiTrigger.hidden = true;
        kesiTrigger.setAttribute('aria-expanded', 'true');
        const email = kesiFields.querySelector('#kesi-email');
        if (email) email.focus();
      });

      // La largeur change => la hauteur idéale change : on re-mesure (débauché).
      let kesiResizeT;
      window.addEventListener('resize', function () {
        clearTimeout(kesiResizeT);
        kesiResizeT = setTimeout(lockKesiHeight, 150);
      }, { passive: true });
    }

    /* En local / hors Shopify (window.Shopify absent), le POST natif n'aboutit pas :
       on intercepte pour montrer la confirmation animée tout de suite. Sur Shopify,
       on laisse le formulaire client poster (capture du lead + rechargement, traité
       ci-dessous via ?customer_posted=true). */
    kesiForm.addEventListener('submit', function (e) {
      if (window.Shopify) return;
      if (!kesiForm.checkValidity()) return;
      e.preventDefault();
      showKesiSuccess(kesiForm);
    });
  }

  if (kesiForm && /[?&]customer_posted=true/.test(window.location.search)) {
    showKesiSuccess(kesiForm);
  }

  /* (Carrousel salon retiré : aucun #salonSlides sur cette page — code mort.) */

  /* ===== Cadres filter tabs ===== */
  (function() {
    const tabs = document.querySelectorAll('.mb-cadres-tabs button');
    const grid = document.getElementById('mb-cadres-grid');
    const count = document.getElementById('mb-cadres-count');
    if (!tabs.length || !grid) return;
    const cards = Array.from(grid.querySelectorAll('.mb-cadre'));
    const reduceCadres = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function applyFilter(filter, animate) {
      let shown = 0;
      cards.forEach((c) => {
        const match = filter === 'all'
          || (filter === 'bestseller' && c.dataset.bestseller === 'true')
          || c.dataset.type === filter;
        c.classList.toggle('is-hidden', !match);
        if (match) shown++;
      });
      if (count) count.textContent = shown + ' modèle' + (shown > 1 ? 's' : '');
      if (animate && !reduceCadres) {
        const vis = cards.filter((c) => !c.classList.contains('is-hidden'));
        vis.forEach((c) => c.classList.remove('mb-cadre--in'));
        void grid.offsetWidth;
        vis.forEach((c, i) => {
          c.style.setProperty('--mb-cadre-d', (i * 55) + 'ms');
          c.classList.add('mb-cadre--in');
        });
      }
    }
    tabs.forEach((t) => {
      t.addEventListener('click', () => {
        tabs.forEach((x) => x.classList.remove('is-active'));
        t.classList.add('is-active');
        applyFilter(t.dataset.filter, true);
      });
    });
    applyFilter('bestseller');
  })();

  /* ===== Video cards — lightbox YouTube (embed) =====
     On joue la vidéo dans une modal via youtube-nocookie.com pour éviter
     que des filtres réseau bloquent www.youtube.com.
     Repli : si l'iframe ne charge pas, on propose un lien direct. */
  (function() {
    const modal = document.getElementById('mbVideoModal');
    const wrap = document.getElementById('mbVideoIframeWrap');
    const closeBtn = modal ? modal.querySelector('.mb-video-modal-close') : null;
    const cards = document.querySelectorAll('.mb-video-card[data-yt]');
    if (!cards.length || !modal || !wrap) return;

    function openModal(id) {
      if (!id) return;
      const safeId = encodeURIComponent(id);
      // On utilise www.youtube.com (et pas -nocookie) : moins d'erreur 153
      // dans les iframes sandboxés. On ajoute l'origin uniquement si la
      // page est servie depuis une vraie URL http(s).
      let params = 'autoplay=1&rel=0&modestbranding=1&playsinline=1';
      if (location.protocol === 'http:' || location.protocol === 'https:') {
        params += '&origin=' + encodeURIComponent(location.origin);
      }
      const src = 'https://www.youtube.com/embed/' + safeId + '?' + params;
      wrap.innerHTML =
        '<iframe src="' + src + '" title="Lecteur vidéo"'
      + ' referrerpolicy="strict-origin-when-cross-origin"'
      + ' allow="autoplay; encrypted-media; picture-in-picture; fullscreen"'
      + ' allowfullscreen></iframe>'
      + '<a class="mb-video-fallback" href="https://www.youtube.com/watch?v=' + safeId + '" target="_blank" rel="noopener noreferrer">Ouvrir sur YouTube</a>';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      wrap.innerHTML = '';
      document.body.style.overflow = '';
    }

    cards.forEach((c) => {
      c.style.cursor = 'pointer';
      c.addEventListener('click', (e) => { e.preventDefault(); openModal(c.dataset.yt); });
      c.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(c.dataset.yt); }
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  })();

  /* ===== Piliers deck — stacked cards ===== */
  (function() {
    const deck = document.getElementById('mbPiliersDeck');
    if (!deck) return;
    const cards = Array.from(deck.querySelectorAll('.mb-pilier-card'));
    const nav = document.querySelectorAll('.mb-piliers-nav-item');
    if (cards.length < 2) return;
    let active = 0;

    function set(idx) {
      active = ((idx % cards.length) + cards.length) % cards.length;
      cards.forEach((c, i) => {
        c.classList.remove('is-active', 'is-next', 'is-after');
        const rel = (i - active + cards.length) % cards.length;
        if (rel === 0) c.classList.add('is-active');
        else if (rel === 1) c.classList.add('is-next');
        else c.classList.add('is-after');
      });
      nav.forEach((n, i) => n.classList.toggle('is-active', i === active));
    }

    // Click on a peeking card → bring it to front
    cards.forEach((c, i) => {
      c.addEventListener('click', (e) => {
        if (c.classList.contains('is-active')) return;
        e.preventDefault();
        set(i);
      });
    });

    // Click on nav numbers
    nav.forEach((n, i) => {
      n.addEventListener('click', () => set(i));
    });

    // Touch swipe support
    let touchStartY = 0, touchStartX = 0;
    deck.addEventListener('touchstart', (e) => {
      touchStartY = e.touches[0].clientY;
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    deck.addEventListener('touchend', (e) => {
      const dy = e.changedTouches[0].clientY - touchStartY;
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dy) > 50 && Math.abs(dy) > Math.abs(dx)) {
        if (dy < 0) set(active + 1); // swipe up → next
        else set(active - 1);          // swipe down → previous
      } else if (Math.abs(dx) > 60) {
        if (dx < 0) set(active + 1);
        else set(active - 1);
      }
    }, { passive: true });

    // Keyboard
    deck.setAttribute('tabindex', '0');
    deck.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); set(active + 1); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); set(active - 1); }
    });

    set(0);

    // Auto-défilement retiré (distill) : le deck ne tourne plus tout seul, pour
    // ne pas concurrencer le marquee logos. Navigation manuelle conservée
    // (clic sur carte / numéros, swipe, flèches clavier ci-dessus).
  })();
})();

/* ===== Vidéothèque : miniatures YouTube + onglets + flèche ===== */
  // ===== Fix YouTube thumbnails when maxresdefault is unavailable =====
  // YouTube renvoie un placeholder gris 120x90 (statut 200) au lieu d'un 404
  // quand maxresdefault.jpg n'existe pas — onerror ne se déclenche donc pas.
  // On détecte la taille au chargement et on bascule sur hqdefault.jpg.
  (function() {
    const thumbs = document.querySelectorAll('.mb-video-thumb');
    thumbs.forEach(function(img) {
      function check() {
        if (img.naturalWidth > 0 && img.naturalWidth <= 120) {
          const m = img.src.match(/\/vi\/([^/]+)\/maxresdefault\.jpg/);
          if (m) {
            img.onerror = null;
            img.src = 'https://img.youtube.com/vi/' + m[1] + '/hqdefault.jpg';
          }
        }
      }
      if (img.complete) check();
      else img.addEventListener('load', check, { once: true });
    });
  })();

  (function() {
    const tabs = document.querySelectorAll('.videos-tab[data-filter]');
    const cards = document.querySelectorAll('#videosGrid > .videos-card');
    if (!tabs.length || !cards.length) return;

    function applyFilter(filter) {
      let firstShown = null;
      const sideCards = [];
      cards.forEach(function(card) {
        const match = card.getAttribute('data-cat') === filter;
        card.classList.toggle('is-hidden', !match);
        card.classList.remove('is-featured');
        card.style.gridRow = '';
        if (match) {
          if (!firstShown) firstShown = card;
          else sideCards.push(card);
        }
      });
      if (firstShown) {
        firstShown.classList.add('is-featured');
        firstShown.style.gridRow = '1 / span ' + Math.max(sideCards.length, 1);
      }
    }

    // Entrée en cascade des cartes visibles après un changement d'onglet
    // (fade + slide, ordre DOM = featured puis colonne de droite). Repli
    // mouvement réduit : aucune animation. Cf [[prefs-animations]].
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function animateCardsIn() {
      if (reduceMotion) return;
      const vis = document.querySelectorAll('#videosGrid > .videos-card:not(.is-hidden)');
      vis.forEach(function(card, i) {
        card.style.setProperty('--mb-rvl-i', Math.min(i, 6));
        card.classList.remove('is-entering');
        void card.offsetWidth; // relance l'animation
        card.classList.add('is-entering');
      });
    }

    // Initial state — feature first visible card
    const activeTab = document.querySelector('.videos-tab.is-active[data-filter]') || tabs[0];
    applyFilter(activeTab.getAttribute('data-filter'));

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        const filter = tab.getAttribute('data-filter');
        tabs.forEach(function(t) {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        applyFilter(filter);
        animateCardsIn();
        positionDownArrow();
      });
    });

    // V5 — aligne la flèche du bas juste sous la dernière carte de la colonne de droite
    const grid = document.getElementById('videosGrid');
    const downArrow = grid && grid.querySelector('.videos-side-arrow--down');
    function positionDownArrow() {
      if (!grid || !downArrow) return;
      const visible = grid.querySelectorAll('.videos-card:not(.is-hidden)');
      // 0 = featured (gauche), 1..n = colonne de droite
      let lastRight = null;
      visible.forEach(function(c, i) { if (i > 0) lastRight = c; });
      if (!lastRight) { downArrow.style.display = 'none'; return; }
      downArrow.style.display = '';
      const gridRect = grid.getBoundingClientRect();
      const cardRect = lastRight.getBoundingClientRect();
      downArrow.style.top = (cardRect.bottom - gridRect.top + 18) + 'px';
    }
    positionDownArrow();
    window.addEventListener('resize', positionDownArrow);
    // Re-positionne quand les images des thumbs finissent de charger (la hauteur peut changer)
    grid && grid.querySelectorAll('img').forEach(function(img) {
      if (!img.complete) img.addEventListener('load', positionDownArrow, { once: true });
    });
  })();

/* ===== Accessoires compris : onglets Mirror / Vision Mono / Vision Deux ===== */
(function () {
  const accTabs  = document.querySelectorAll('.acc-inclus-tab');
  const accPanes = document.querySelectorAll('.acc-inclus-pane');
  if (!accTabs.length) return;
  accTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.getAttribute('data-acc-target');
      accTabs.forEach((t) => t.classList.toggle('is-active', t === tab));
      accPanes.forEach((p) => p.classList.toggle('is-active', p.getAttribute('data-acc-pane') === target));
    });
  });

  /* ── Cartes gamme cliquables (ex-handlers onclick/onkeydown inline) ──
     Carte entière cliquable vers data-href ; un clic sur les boutons internes
     (.gamme-card-buttons) ne déclenche pas la navigation. Entrée = activer. */
  document.querySelectorAll('.gamme-card[data-href]').forEach((card) => {
    const go = () => { window.location.href = card.dataset.href; };
    card.addEventListener('click', (e) => {
      if (e.target.closest('.gamme-card-buttons')) return;
      go();
    });
    card.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') go();
    });
  });
})();

/* ====== Chrome : tiroir panier + méga-menu + navigation mobile ====== */
(function () {
  const btn = document.querySelector('#open-cart');
  const drawer = document.querySelector('#cart-drawer');
  const closeBtn = document.querySelector('#close-cart');
  if (!btn || !drawer) return;

  const scrim = document.createElement('div');
  scrim.className = 'cart-scrim';
  document.body.appendChild(scrim);

  let lastFocus = null;
  const isOpen = () => drawer.classList.contains('is-open');

  function open() {
    lastFocus = document.activeElement;
    drawer.inert = false; /* hors inert avant de focaliser */
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    scrim.classList.add('is-open');
    document.body.classList.add('cart-open');
    btn.setAttribute('aria-expanded', 'true');
    if (closeBtn) closeBtn.focus();
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    scrim.classList.remove('is-open');
    document.body.classList.remove('cart-open');
    btn.setAttribute('aria-expanded', 'false');
    /* inert : sort les boutons du tiroir fermé du parcours clavier + lecteur
       d'écran (même correctif que le tiroir mobile). On le pose avant de rendre
       le focus pour que celui-ci quitte le tiroir proprement. */
    drawer.inert = true;
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  btn.setAttribute('aria-expanded', 'false');
  drawer.inert = true; /* fermé au départ */
  btn.addEventListener('click', () => { isOpen() ? close() : open(); });
  if (closeBtn) closeBtn.addEventListener('click', close);
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && isOpen()) close(); });
})();
(function () {
  const root     = document.querySelector('.smm-root');
  if (!root) return;
  const items    = root.querySelectorAll('.smm-nav__item[data-menu]');
  const megamenu = root.querySelector('.smm-megamenu');
  const panels   = root.querySelectorAll('.smm-mm__panel');
  const scrim    = document.querySelector('.smm-scrim');
  let closeTimer = null;

  function openPanel(key) {
    clearTimeout(closeTimer);
    panels.forEach(p => p.classList.toggle('is-active', p.dataset.panel === key));
    items.forEach(i  => i.classList.toggle('is-open',   i.dataset.menu  === key));
    megamenu.classList.add('is-open');
    if (scrim) scrim.classList.add('is-open');
  }

  function scheduleClose() {
    closeTimer = setTimeout(() => {
      megamenu.classList.remove('is-open');
      items.forEach(i => i.classList.remove('is-open'));
      if (scrim) scrim.classList.remove('is-open');
    }, 180);
  }

  items.forEach(item => {
    const key = item.dataset.menu;
    item.addEventListener('mouseenter', () => openPanel(key));
    item.addEventListener('mouseleave', scheduleClose);
    const btn = item.querySelector('.smm-nav__link');
    if (btn) btn.addEventListener('click', e => {
      e.preventDefault();
      item.classList.contains('is-open') ? scheduleClose() : openPanel(key);
    });
  });

  if (megamenu) {
    megamenu.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    megamenu.addEventListener('mouseleave', scheduleClose);
  }
  if (scrim) scrim.addEventListener('click', () => {
    megamenu.classList.remove('is-open');
    items.forEach(i => i.classList.remove('is-open'));
    scrim.classList.remove('is-open');
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      megamenu.classList.remove('is-open');
      items.forEach(i => i.classList.remove('is-open'));
      if (scrim) scrim.classList.remove('is-open');
    }
  });

  /* Repli de la barre d'annonce au scroll */
  const ab = root.querySelector('.smm-ab');
  function syncAbHeight() {
    if (!ab) return;
    const h = ab.getBoundingClientRect().height;
    if (h > 0) root.style.setProperty('--smm-ab-h', h + 'px');
  }
  syncAbHeight();
  window.addEventListener('resize', syncAbHeight, { passive: true });

  let ticking = false;
  function updateScrollState() {
    root.classList.toggle('is-scrolled', (window.scrollY || window.pageYOffset) > 40);
    ticking = false;
  }
  window.addEventListener('scroll', () => {
    if (!ticking) { window.requestAnimationFrame(updateScrollState); ticking = true; }
  }, { passive: true });
  updateScrollState();
})();
(function () {
  const root = document.querySelector('.smm-root');
  if (!root) return;
  const burger = root.querySelector('.smm-burger');
  if (!burger) return;
  const items = [...root.querySelectorAll('.smm-nav__item[data-menu]')];

  const chevSVG = '<svg class="smm-mnav__acc-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';

  const nav = document.createElement('aside');
  nav.className = 'smm-mnav';
  nav.id = 'smm-mnav';
  nav.setAttribute('role', 'dialog');
  nav.setAttribute('aria-modal', 'true');
  nav.setAttribute('aria-label', 'Menu principal');

  /* En-tête : logo + fermer */
  const top = document.createElement('div');
  top.className = 'smm-mnav__top';
  const logoImg = root.querySelector('.smm-header__logo img');
  const logoSrc = logoImg ? logoImg.getAttribute('src') : '../assets/logo-maison-broderie.png';
  top.innerHTML =
    '<a class="smm-mnav__logo" href="/" aria-label="Maison Broderie, accueil"><img src="' + logoSrc + '" alt="Maison Broderie" /></a>' +
    '<button class="smm-mnav__close" type="button" aria-label="Fermer le menu"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';
  nav.appendChild(top);

  /* Corps : CTA devis + accordéon + liens directs */
  const body = document.createElement('div');
  body.className = 'smm-mnav__body';

  const ctaSrc = root.querySelector('.smm-nav__link--cta');
  const cta = document.createElement('a');
  cta.className = 'btn btn-primary smm-mnav__cta';
  cta.href = ctaSrc ? ctaSrc.getAttribute('href') : '#devis';
  cta.textContent = ctaSrc ? ctaSrc.textContent.trim() : 'Demander un devis';
  body.appendChild(cta);

  items.forEach(item => {
    const key = item.dataset.menu;
    const trg = item.querySelector('.smm-nav__link');
    const label = trg ? trg.textContent.trim() : key;
    const panelSrc = root.querySelector('.smm-mm__panel[data-panel="' + key + '"]');

    const acc = document.createElement('div');
    acc.className = 'smm-mnav__acc';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'smm-mnav__acc-trigger';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', 'mnav-panel-' + key);
    btn.innerHTML = '<span>' + label + '</span>' + chevSVG;

    const panel = document.createElement('div');
    panel.className = 'smm-mnav__acc-panel';
    panel.id = 'mnav-panel-' + key;
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-label', label);

    const inner = document.createElement('div');
    inner.className = 'smm-mnav__acc-inner';
    if (panelSrc) {
      panelSrc.querySelectorAll('.smm-col').forEach(col => inner.appendChild(col.cloneNode(true)));
    }
    inner.inert = true; /* contenu replié : hors du parcours clavier */
    panel.appendChild(inner);

    btn.addEventListener('click', () => {
      const willOpen = !acc.classList.contains('is-open');
      if (willOpen) {
        nav.querySelectorAll('.smm-mnav__acc.is-open').forEach(other => {
          other.classList.remove('is-open');
          const ob = other.querySelector('.smm-mnav__acc-trigger');
          const oi = other.querySelector('.smm-mnav__acc-inner');
          if (ob) ob.setAttribute('aria-expanded', 'false');
          if (oi) oi.inert = true;
        });
      }
      acc.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      inner.inert = !willOpen;
    });

    acc.appendChild(btn);
    acc.appendChild(panel);
    body.appendChild(acc);
  });

  const directSrc = [...root.querySelectorAll('.smm-ab__links a:not(.smm-ab__premium)')];
  if (directSrc.length) {
    const direct = document.createElement('div');
    direct.className = 'smm-mnav__direct';
    directSrc.forEach(a => {
      const l = document.createElement('a');
      l.href = a.getAttribute('href') || '#';
      l.textContent = a.textContent.trim();
      direct.appendChild(l);
    });
    body.appendChild(direct);
  }
  nav.appendChild(body);

  /* Pied : téléphone + Espace Premium */
  const foot = document.createElement('div');
  foot.className = 'smm-mnav__foot';
  const phoneSrc = root.querySelector('.smm-ab__phone');
  if (phoneSrc) {
    const ph = document.createElement('a');
    ph.className = 'smm-mnav__phone';
    ph.href = phoneSrc.getAttribute('href');
    ph.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg><span>04 12 10 37 10</span>';
    foot.appendChild(ph);
  }
  const premSrc = root.querySelector('.smm-ab__premium');
  if (premSrc) {
    const pr = document.createElement('a');
    pr.className = 'smm-mnav__premium';
    pr.href = premSrc.getAttribute('href') || '#';
    pr.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg><span>Espace Premium</span>';
    foot.appendChild(pr);
  }
  nav.appendChild(foot);

  const scrim = document.createElement('div');
  scrim.className = 'smm-mnav__scrim';

  document.body.appendChild(scrim);
  document.body.appendChild(nav);
  nav.inert = true; /* fermé au départ */

  const closeBtn = top.querySelector('.smm-mnav__close');
  let lastFocus = null;

  burger.setAttribute('aria-controls', 'smm-mnav');
  burger.setAttribute('aria-expanded', 'false');

  const isOpen = () => nav.classList.contains('is-open');

  function open() {
    lastFocus = document.activeElement;
    nav.inert = false;
    nav.classList.add('is-open');
    scrim.classList.add('is-open');
    document.body.classList.add('smm-mnav-open');
    burger.setAttribute('aria-expanded', 'true');
    closeBtn.focus();
  }
  function close() {
    nav.classList.remove('is-open');
    scrim.classList.remove('is-open');
    document.body.classList.remove('smm-mnav-open');
    burger.setAttribute('aria-expanded', 'false');
    nav.inert = true;
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  burger.addEventListener('click', () => { isOpen() ? close() : open(); });
  closeBtn.addEventListener('click', close);
  scrim.addEventListener('click', close);

  /* Un clic sur un lien ferme le tiroir */
  nav.addEventListener('click', e => { if (e.target.closest('a')) close(); });

  /* Échap ferme ; Tab reste piégé dans le tiroir ouvert */
  nav.addEventListener('keydown', e => {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    const list = [...nav.querySelectorAll('a[href], button:not([disabled])')]
      .filter(el => !el.closest('[inert]'));
    if (!list.length) return;
    const first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Repli automatique si l'on repasse en disposition desktop */
  window.addEventListener('resize', () => {
    if (isOpen() && window.innerWidth >= 881) close();
  }, { passive: true });
})();
